/* eslint-disable jira/filename-case */
import {
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
} from '@jira/platform__common-constants/src/project-template-type-keys.tsx';

export const PACKAGE_NAME = 'jiraServicedeskGettingStartedPage';

export const UNKNOWN_PROJECT_TEMPLATE_KEY = '';

export const GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES: string[] = [
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY,
	BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY,
	UNKNOWN_PROJECT_TEMPLATE_KEY,
];

export const PACKAGE_TEAM_NAME = 'Sequoia';

export const DISABLE_NPLE_PROJECT_PROJECT_KEY = 'npleDisabled';

export const DEMO_ISSUE_LABEL = 'onboarding-learn-by-doing-demo-issue';
export const DEMO_ISSUE_ERROR_FLAG_ID = 'onboarding-sample-issue-error';

export const ManageQueuesArticleId = '5b7BuVaVJqmbyCZ2mbMYHD';
export const ViewIssueArticleId = '102lbF25oEeqn7GG1rXPUA';

export const DISABLE_NPLE_ERROR_FLAG_ID = 'disable-nple-error';
export const DISABLE_NPLE_SUCCESS_FLAG_ID = 'disable-nple-success';
